module.exports = __webpack_public_path__ + "img/design__default_icon-qr-kbmark.93bfea14.svg";